
<section class="overview-area ptb-100">
    <app-overview [data]="content"></app-overview>
</section>

<app-app-download></app-app-download>